import { render, staticRenderFns } from "./RatingDetail.vue?vue&type=template&id=3f9ec10a&"
import script from "./RatingDetail.vue?vue&type=script&lang=js&"
export * from "./RatingDetail.vue?vue&type=script&lang=js&"
import style0 from "./RatingDetail.vue?vue&type=style&index=0&id=3f9ec10a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports